const testComment = `ここにコメントが入ります。ここにコメントが入ります。ここにコメントが入ります。
ここにコメントが入ります。ここにコメントが入ります。ここにコメントが入ります。
ここにコメントが入ります。ここにコメントが入ります。ここにコメントが入ります。`;

/**
 * ディレクター
 */
export const okamotoTakaya = `こんなビッグタイトルの原作漫画を朗読劇にできることを、心から嬉しく思います。このためにとても豪華で役にぴったりなキャスト陣が集まってくれました。戦国武将と恋に落ちる女子高生の物語。生バンドにのせて、楽しくお届けします。この夏は皆さんも一緒にタイムスリップしましょう！
いざ、戦国時代へ！

【プロフィール】
劇作家・演出家。劇団ミュ主宰。朗読劇の金字塔ともいえる『私の頭の中の消しゴム』（13年連続で上演が続く）、『朗読劇 陰陽師』シリーズ、『こえかぶ』『ヘブンズ・レコード』『世界が記憶であふれる前に』『君の名前で僕を呼んで〜5th anniversary～』など、多数の朗読劇や舞台を手がける。神戸出身。`;

export const tsuthiyaYusaku = `主人公・唯のスリリングな青春を生バンドで軽快にお届けします。舞台でしか表現できないダイナミックな演出とキャストごとの化学変化が、生演奏と絡んで盛り上がっていくことでしょう！
刮目くださいませ。

【プロフィール】
音楽監督、作編曲家、オーケストレーター、ヴァイオリニスト。東京都出身。
幼少期は日本の伝統芸能である能の子方として活動し、6 歳よりヴァイオリンの師事を受け始める。SIBERIAN NEWSPAPER としてFUJI ROCK FESTIVAL 07’に出演。
現在はその多彩な音楽性を活かし、舞台、アニメ、CM、ゲーム、コンベンションなど様々な音楽制作を手がける。演奏家としては尺八、太鼓奏者等と共にALIAKE を結成し和楽器にも傾倒。録音専門オーケストラgaQdan音楽監督現任。`;

/**
 * 演奏家
 */
export const nakahara = `【プロフィール】
武蔵野音楽大学音楽学部器楽学科打楽器専攻卒、同特修科修了。
マリンバ、打楽器を奥田昌史、高田みどり、中谷孝哉、高橋美智子、吉原すみれの各氏に、ピアノを今込裕子、林ナナ子の各氏に師事。
EX「題名のない音楽会」出演、プロオーケストラでの演奏等の活動に従事し、ピアニストとしてもクラシック曲の伴奏やジャズ等、ジャンルを問わず活動。
卒業後キーボーディストとしての活動を本格化、打楽器奏者としては吹奏楽や宮内庁内の午餐、晩餐での演奏も担当。
`;

export const makiyama = `【プロフィール】
熊本出身。10歳でエレクトリックベースを始め、地元のビックバンドでジャズを学ぶ。
その後2017年に奨学金を受け、米国ボストンにあるバークリー音楽大学に留学。
帰国後に活動拠点を東京に移し、都内でのライブ活動を開始。
様々なアーティストのサポートや、自身のバンド”パジャマで海なんかいかない”の活動、アニメ、CM等のスタジオレコーディング等、多方面で活躍している。`;

export const suzuki = `【プロフィール】
尚美学園大学ジャズ＆ポップスコースドラム専攻卒業。ドラムを木村由紀夫氏、パーカッションを中北裕子氏、塩のやもとひろ氏に師事。大学ではジャズドラムを学び、在学中より関東のジャズバーを中心にライブ活動を開始。
卒業後はジャズのみならずミュージカル、ポップス、ゴスペル、ファンクなど様々なジャンルで活動。近年はパーカッションの演奏にも力を入れている。
2017年～2019年東京ブラススタイルに所属。Bosphorusエンドースアーティスト。`;

/**
 * 原作著者
 */
export const morimotoKozueko = `私もかれこれウン十年、長ーく漫画を描いておりますが、アシガールは特別な思い入れがあり、連載を終えるのがとてもさびしかった作品です。
ですから今回、新たに朗読劇として生まれ変わり、唯や若君たちと再び会えるのが本当に嬉しいです。
私は朗読劇を観るのは初めてなのですが、素敵なキャストの皆様がどんなアシガールの世界を演じてくださるのかとても楽しみです！
より多くの皆様に観て、聴いて、楽しんでいただきたいと思っています。

【プロフィール】
2月27日生まれ。熊本県出身。O型。1985年、「抱き寄せてプロポーズ」で『YOU増刊VIVID YOU』にてデビュー。
代表作：「ごくせん」「デカワンコ」「高台家の人々」など。`;
